<template>
	<div class="header-bar">

		<div style="display:flex;align-items:center;">
			<Button size="large" v-if="$store.state.app.currentPage!='home'" @click="backUppage">
				<Icon type="ios-arrow-back"/>
				返回
			</Button>
			<p style="height:26px; width:2px;background:#dedede;margin:0 14px;" v-if="$store.state.app.currentPage!='home'"/>
			<!--<Icon type="ios-home" size="30"/>
			<a style="margin:0 16px 0 4px;" @click="backHome"><b>首页</b></a>-->

			<Dropdown v-if="$store.state.app.currentPage==='preSorting'" v-model="$store.state.preSortingType"
			          @on-click="changePreSortingTypeCallback">
				<a>
					{{$store.state.preSortingType==1?'全部商品':'参考销售情况'}}
					<Icon type="ios-arrow-down"/>
				</a>
				<DropdownMenu slot="list">
					<DropdownItem v-if="$store.state.preSortingType==2" :name="1">全部商品</DropdownItem>
					<DropdownItem v-if="$store.state.preSortingType==1" :name="2">参考销售情况</DropdownItem>
				</DropdownMenu>
			</Dropdown>
			<p style="height:26px; width:2px;background:#dedede;margin:0 14px;"
			   v-if="$store.state.app.currentPage==='preSorting' && $store.state.preSortingType==2"/>

			<div v-if="$store.state.app.currentPage!=='preSorting' || $store.state.preSortingType==2">
				<Select style="width:120px;margin-right: 5px;" size="large" v-model="$store.state.dateType"
				        @on-change="changeDateTypeCallback">
					<Option :value="1" label="按配送日期"><b>按配送日期</b></Option>
					<Option :value="2" label="按运营时间"><b>按运营时间</b></Option>
				</Select>

				<Dropdown @on-click="changeSortingTime" v-if="$store.state.dateType==1">
					<a>
						{{$store.state.sortingTimeSetting.sortingTimeName}}
						({{timeUtil.dateFormat($store.state.sortingTimeSetting.sortingStartTime,'M月D日 H:mm')}}
						~
						{{timeUtil.dateFormat($store.state.sortingTimeSetting.sortingEndTime,'M月D日 H:mm')}})
						<Icon type="ios-arrow-down"/>
					</a>
					<DropdownMenu slot="list">
						<DropdownItem v-for="(item,index) in $store.state.sortingTimes" :key="index"
						              :name="index" :selected="$store.state.currentSortingTimeIndex==index">
							<span>{{item.name?item.name:"未命名"}}</span>
							<span v-if="item.beforeDay>=0">({{timeUtil.dateFormat(timeUtil.computeDateByDay(timeUtil.getDate(),-item.beforeDay),"M月DD日")}}</span>
							<span v-if="item.beforeDay<0">({{timeUtil.dateFormat(timeUtil.computeDateByDay(timeUtil.getDate(),item.beforeDay),"M月D日")}}</span>
							<span>{{item.startHour}}</span>
							<span>~</span>
							<span>{{timeUtil.dateFormat(timeUtil.computeDateByDay(timeUtil.getDate(),item.endDay),"M月D日")}}</span>
							<span>{{item.endHour}})</span>
							<!--({{timeUtil.dateFormat(item.sortingTimeSetting.sortingStartTime,'MM月DD日 HH:mm')}}~
							{{timeUtil.dateFormat(item.sortingTimeSetting.sortingEndTime,'MM月DD日 HH:mm')}})-->
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>

				<Dropdown v-if="$store.state.dateType==2" trigger="custom" :visible="showDateVisible"
				          @on-clickoutside="closeDateModal">
					<a @click="showDateVisible=true">
						{{timeUtil.dateFormat($store.state.sortingTimeSetting.sortingStartTime,"M月D日")}}
						{{$store.state.sortingTimeSetting.sortingTimeName}}
						<Icon type="ios-arrow-down"/>
					</a>
					<DropdownMenu slot="list">
						<Row :gutter="12" style="width: 1024px;height: 540px;">
							<Col span="8">
								<div style="padding-left: 12px;" v-for="(item,index) of $store.state.operationTimes" :key="index">
									<Button size="large" :type="$store.state.currentSortingTimeIndex==index?'success':'default'"
									        style="width: 100%;"
									        @click="changeOperationDateCallback(index)">
										{{item.title}}
									</Button>
								</div>
							</Col>
							<Col span="16" style="padding: 8px 20px 0px 10px;">
								<div style="height: 60px;text-align: center;border: 1px solid #e4e7ed;">
									<b>当前选择：</b>
									<b>{{$store.state.sortingTimeSetting.sortingTimeDesc}}</b>
								</div>
								<eleCalendar :data="[]" prop="date" :render-content="renderContent" :currentmonth="true" :highlight="true"
								             selectionMode="day" :border="true" @pick="changeDateCallback"/>
							</Col>
						</Row>
						<!--<div style="padding: 12px;">
							<Button size="large" style="width: 50%;">取消</Button>
							<Button size="large" type="success" style="width: 49%;">确认</Button>
						</div>-->
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>
		<div class="custom-content-con">
			<slot/>
		</div>
	</div>

</template>
<script>
	// import customBreadCrumb from './custom-bread-crumb'
	import "./header-bar.less";
	import eleCalendar from "ele-calendar";
	import "@/assets/css/vue-calendar.css";
	// import 'ele-calendar/dist/vue-calendar.css';
	import {getOperationTimeDesc} from "@/libs/util";

	const timeUtil = require("@/libs/timeUtil");

	export default {
		name: 'HeaderBar',
		inject: ["reloadContent"],
		components: {
			eleCalendar
			// customBreadCrumb
		},
		props: {
			collapsed: Boolean
		},
		data() {
			return {
				showDateVisible: false,
				timeUtil,
			}
		},
		computed: {
			breadCrumbList() {
				return this.$store.state.app.breadCrumbList
			}
		},
		methods: {
			renderContent(h, parmas) {
				const loop = data => {
					return (
						data.defvalue.value ? (<div>
							<div style="font-size:20px;">{data.defvalue.text}</div>
						</div>) : <div style="font-size:20px;">{data.defvalue.text}</div>
					)
				};
				return (
					<div style="min-height:60px;">
						<b>{loop(parmas)}</b>
					</div>
				);
			},
			// 返回首页
			backHome() {
				this.$router.push({name: "home",});
			},
			// 返回上个页面
			backUppage() {
				this.$router.go(-1);
			},
			// 选择时间类型回调
			changeDateTypeCallback(event) {
				this.$store.state.dateType = event;
				if (event == 1) {
					this.changeSortingTime(0);
				}
				if (event == 2) {
					this.changeOperationDateCallback(0);
					this.showDateVisible = true;
				}
				localStorage.setItem("dateType", event);
			},
			// 选择预分拣类型
			changePreSortingTypeCallback(event) {
				this.$store.state.preSortingType = event;
				if (event == 1) {
					// this.changeSortingTime(0);
				}
				if (event == 2) {
					// this.changeOperationDateCallback(0);
					// this.showDateVisible = true;
				}
				// localStorage.setItem("preSortingType", event);
				this.reloadContent();
			},
			// 选择分拣时间
			changeSortingTime(index) {
				if (index >= this.$store.state.sortingTimes.length)
					index = 0;
				let data = this.$store.state.sortingTimes[index];
				this.$store.state.sortingTimeSetting.sortingTimeName = data.name;
				if (data.beforeDay < 0)
					data.beforeDay = -data.beforeDay;
				this.$store.state.sortingTimeSetting.sortingStartTime = timeUtil.dateFormat(timeUtil.computeDateByDay(timeUtil.getDate(), -data.beforeDay), "YYYY-MM-DD") + " " + data.startHour;
				this.$store.state.sortingTimeSetting.sortingEndTime = timeUtil.dateFormat(timeUtil.computeDateByDay(timeUtil.getDate(), data.endDay), "YYYY-MM-DD") + " " + data.endHour;
				this.$store.state.sortingTimeSetting.spuCategoryIds = [];
				if (data.categoryList && data.categoryList.length) {
					for (let i = 0; i < data.categoryList.length; i++) {
						this.$store.state.sortingTimeSetting.spuCategoryIds.push(data.categoryList[i].id);
					}
				}
				this.$store.state.currentSortingTimeIndex = index;
				localStorage.setItem("sortingTimeIndex", index);
				this.reloadContent();
			},
			// 关闭日历窗口
			closeDateModal() {
				this.showDateVisible = false;
			},
			// 选择运营日期回调
			changeOperationDateCallback(index) {
				if (index >= this.$store.state.operationTimes.length)
					index = 0;
				this.$store.state.currentSortingTimeIndex = index;
				this.$store.state.sortingTimeSetting.sortingTimeName = this.$store.state.operationTimes[index].title;
				localStorage.setItem("sortingTimeIndex", index);
				getOperationTimeDesc(this.$store.state);
			},
			// 选择日期回调
			changeDateCallback(date, event, row, dom) {
				let selectDate = timeUtil.dateFormat(date, "YYYY-MM-DD");
				this.$store.state.sortingTimeSetting.sortingStartTime = selectDate;
				this.$store.state.sortingTimeSetting.sortingEndTime = selectDate;
				getOperationTimeDesc(this.$store.state);
				this.showDateVisible = false;
				this.reloadContent();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/main/components/header-bar/header-bar.vue